import { api_put } from "services/api";
import { PROYECT } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { loginTypes } from "redux/reducers/login/loginTypes";
import { push } from "connected-react-router";
import { api_post } from "services/api";
import { api_delete } from "services/api";
import { restoreFlotillasStore } from "../notesFlotilla/notesFlotillaActions";
import { getItemLocalStorage } from "helpers/localstorageTool";
import { api_get } from "services/api";


const {
  SET_INFO_LOGIN,
  CLOSE_SESSION_LOGIN,
  NEW_PRINTER,
  // EDIT_PRINTER,
  DELETE_PRINTER,
  SET_INACTIVE_SESSION,
  SET_MS_URL,
  SEND_MS_DATA
} = loginTypes;

export const loginAction = ( form, hist ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/auth/login`;
  return async dispatch => {
    dispatch(startRequestComp('loginLoading'))
    await api_post(url, form).then(response => {
      if (!response.stations || response.stations.length === 0) {
        dispatch(setSnackbar('No tienes permisos de acceso. Contacta al administrador.'))
        dispatch(stopRequestComp('loginLoading'))
        return;
      }
      dispatch({
        type: SET_INFO_LOGIN,
        payload: {...response, username: form.username}
      });
      localStorage.setItem("crm-user", response.token);
    //  push("/admin/dashboard")
      dispatch(stopRequestComp('loginLoading'))
      dispatch(setInactiveSession(false))
      const route = getItemLocalStorage("route")
      route ? hist.push(route) : hist.push("/admin/dashboard")
    }).catch(err => {
      dispatch(setSnackbar(err?.message ? err.message : err))
      dispatch(stopRequestComp('loginLoading'))
    })
  }

}

export const loginMSAction = (form, hist) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/auth/msauth`;
  return async dispatch => {
      await api_post(url, form).then(response => {
        if (response.username == 'oncall') {
          dispatch({
            type: SET_INFO_LOGIN,
            payload: response
          });
          localStorage.setItem("crm-user", response.token);
          hist.replace("/admin/dashboard")
        } else {
          dispatch({
            type: SET_MS_URL,
            payload: response.redirectUrl
          })
          window.location.replace(response.redirectUrl)
        }
      }).catch(error => {
        dispatch(setSnackbar(error))
      })
  }
}

export const getUserInfoByToken = (token, hist) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/auth/login/microsoft`;
  return async dispatch => {
    await api_post(url, token).then(resp => {
      if (!resp.stations || resp.stations.length === 0) {
        dispatch(setSnackbar('No tienes permisos de acceso. Contacta al administrador.'))
        hist.replace("/auth/login");
        return;
      }
      dispatch({
        type: SET_INFO_LOGIN,
        payload: {...resp, username: resp.username}
      });
      localStorage.setItem("crm-user", resp.token);
      hist.replace("/admin/dashboard")
    }).catch(err => {
      dispatch(setSnackbar(err || 'Error de de autenticación, contacte a soporte'));
      hist.replace("/auth/login");
    })
  }
}

export const resetUserPassword = ( username, setIsResetPassword ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/users/${username}/password/reset`;
  return async dispatch => {
    dispatch(startRequestComp('loginLoading'))
    await api_put(url, {username}).then(response => {
      dispatch(setSnackbar(`Se ha enviado un correo a la cuenta asociada.`, 'success'))
      setIsResetPassword()
      dispatch(stopRequestComp('loginLoading'))
      
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loginLoading'))
    })
  }
}

export const registerNewPrinter = ( form ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/printers`;
  return async dispatch => {
    await api_post(url, form).then(response => {
      dispatch({
        type: NEW_PRINTER,
        payload: response
      })
      dispatch(setSnackbar(`Nueva impresora registrada`, 'success'))
      
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loginLoading'))
    })
  }
}

export const editPrinter = ( id, form ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/printers/${id}`;
  return async dispatch => {
    await api_put(url, form).then(response => {
      dispatch({
        // type: EDIT_PRINTER,
        payload: {...response, id}
      })
      dispatch(setSnackbar(`Impresora editada`, 'success'))
      
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loginLoading'))
    })
  }
}

export const deletePrinter = ( id ) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/printers/${id}`;
  return async dispatch => {
    await api_delete(url).then(response => {
      dispatch({
        type: DELETE_PRINTER,
        payload: id
      })
      dispatch(setSnackbar(`Impresora eliminada`, 'success'))
      
    }).catch(err => {
      dispatch(setSnackbar(err))
      dispatch(stopRequestComp('loginLoading'))
    })
  }
}

export const sendMsData = (data) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/auth/msauth/token`
  return async dispatch => {
    await api_post(url, data).then(response => {
      dispatch({
        type: SEND_MS_DATA,
        payload: response
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
  }
}

export const closeSession = () => (dispatch) => {
  localStorage.removeItem("crm-user");
  dispatch({ type: CLOSE_SESSION_LOGIN });
};

export const setInactiveSession = (input=false) => {
  return {
    type: SET_INACTIVE_SESSION,
    payload: input
  }
}